import { render, staticRenderFns } from "./PtiPresuntivoSinSDI.vue?vue&type=template&id=4a4c8170&scoped=true"
import script from "./PtiPresuntivoSinSDI.vue?vue&type=script&lang=js"
export * from "./PtiPresuntivoSinSDI.vue?vue&type=script&lang=js"
import style0 from "./PtiPresuntivoSinSDI.vue?vue&type=style&index=0&id=4a4c8170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c8170",
  null
  
)

export default component.exports